// extracted by mini-css-extract-plugin
export default {"ErrorDniMessageStep":"ErrorDniMessageStep_ErrorDniMessageStep__6n4f3"};